import React, { useState, useEffect, useRef } from 'react';

function SleepTimer({ onTimerEnd }) {
  const [showMenu, setShowMenu] = useState(false);
  const [remaining, setRemaining] = useState(null);
  const timerRef = useRef(null);
  const menuRef = useRef(null);

  // Close menu on click outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setShowMenu(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Timer countdown
  useEffect(() => {
    if (remaining === null) return;

    if (remaining <= 0) {
      onTimerEnd();
      setRemaining(null);
      return;
    }

    timerRef.current = setTimeout(() => {
      setRemaining(prev => prev - 1);
    }, 1000);

    return () => clearTimeout(timerRef.current);
  }, [remaining, onTimerEnd]);

  const startTimer = (minutes) => {
    setRemaining(minutes * 60);
    setShowMenu(false);
  };

  const cancelTimer = () => {
    clearTimeout(timerRef.current);
    setRemaining(null);
    setShowMenu(false);
  };

  const formatRemaining = (seconds) => {
    if (seconds === null) return '';
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    if (m > 0) return `${m}:${s.toString().padStart(2, '0')}`;
    return `${s}s`;
  };

  const isActive = remaining !== null;

  return (
    <div className="sleep-timer-wrapper" ref={menuRef}>
      <button
        className={`ctrl-btn sleep-timer-btn ${isActive ? 'sleep-active' : ''}`}
        onClick={() => setShowMenu(!showMenu)}
        title={isActive ? `Sommeil: ${formatRemaining(remaining)}` : 'Timer sommeil'}
      >
        {isActive ? (
          <span className="sleep-countdown">{formatRemaining(remaining)}</span>
        ) : (
          <span className="sleep-icon">🌙</span>
        )}
      </button>

      {showMenu && (
        <div className="sleep-timer-menu">
          <div className="sleep-menu-title">Timer sommeil</div>
          {isActive ? (
            <>
              <div className="sleep-menu-active">
                ⏱️ Arrêt dans {formatRemaining(remaining)}
              </div>
              <button className="sleep-menu-item sleep-cancel" onClick={cancelTimer}>
                ✕ Annuler le timer
              </button>
            </>
          ) : (
            <>
              <button className="sleep-menu-item" onClick={() => startTimer(15)}>
                15 minutes
              </button>
              <button className="sleep-menu-item" onClick={() => startTimer(30)}>
                30 minutes
              </button>
              <button className="sleep-menu-item" onClick={() => startTimer(45)}>
                45 minutes
              </button>
              <button className="sleep-menu-item" onClick={() => startTimer(60)}>
                1 heure
              </button>
              <button className="sleep-menu-item" onClick={() => startTimer(90)}>
                1h30
              </button>
              <button className="sleep-menu-item" onClick={() => startTimer(120)}>
                2 heures
              </button>
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default SleepTimer;
